import { useContext } from 'react'

import { TiptapContext } from '../TiptapContext'

export const useTiptap = () => useContext(TiptapContext)
